import { render, staticRenderFns } from "./TwitterShareButton.vue?vue&type=template&id=10ddd52e&scoped=true&"
import script from "./TwitterShareButton.vue?vue&type=script&lang=js&"
export * from "./TwitterShareButton.vue?vue&type=script&lang=js&"
import style0 from "./TwitterShareButton.vue?vue&type=style&index=0&id=10ddd52e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10ddd52e",
  null
  
)

export default component.exports